import { render, staticRenderFns } from "./BemVindo.vue?vue&type=template&id=03d8d767&"
import script from "./BemVindo.vue?vue&type=script&setup=true&lang=js&"
export * from "./BemVindo.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./BemVindo.vue?vue&type=style&index=0&id=03d8d767&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports